import {
  INIT_PAYMENTS_REQUEST,
  INIT_PAYMENTS_SUCCESS,
  INIT_PAYMENTS_ERROR,
  INIT_PAYMENTS_REDIRECTING,
  RESET_PAYMENTS,
} from '../actions/payments';

export const initialState = {
  clientToken: null,
  isInitialized: false,
  isInitPaymentsInProgress: false,
  isInitPaymentsError: false,
  isRedirecting: false,
};

export default function addPaymentInitReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_PAYMENTS_REQUEST:
      return {
        ...state,
        isInitPaymentsInProgress: true,
      };
    case INIT_PAYMENTS_SUCCESS:
      return {
        ...state,
        clientToken: action.token,
        isInitialized: true,
        isInitPaymentsError: false,
        isInitPaymentsInProgress: false,
      };
    case INIT_PAYMENTS_ERROR:
      return {
        ...state,
        isInitialized: true,
        isInitPaymentsError: true,
        isInitPaymentsInProgress: false,
      };
    case INIT_PAYMENTS_REDIRECTING:
      return {
        ...state,
        isRedirecting: true,
      };
    case RESET_PAYMENTS:
      return initialState;
    default:
      return state;
  }
}
